/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseAdyenDataphonesInner
 */
export interface GetConfig200ResponseAdyenDataphonesInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseAdyenDataphonesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseAdyenDataphonesInner
     */
    poiid?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseAdyenDataphonesInner
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseAdyenDataphonesInner
     */
    ip?: string | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseAdyenDataphonesInner interface.
 */
export function instanceOfGetConfig200ResponseAdyenDataphonesInner(value: object): value is GetConfig200ResponseAdyenDataphonesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseAdyenDataphonesInnerFromJSON(json: any): GetConfig200ResponseAdyenDataphonesInner {
    return GetConfig200ResponseAdyenDataphonesInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseAdyenDataphonesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseAdyenDataphonesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'poiid': json['poiid'] == null ? undefined : json['poiid'],
        'name': json['name'] == null ? undefined : json['name'],
        'ip': json['ip'] == null ? undefined : json['ip'],
    };
}

export function GetConfig200ResponseAdyenDataphonesInnerToJSON(json: any): GetConfig200ResponseAdyenDataphonesInner {
    return GetConfig200ResponseAdyenDataphonesInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseAdyenDataphonesInnerToJSONTyped(value?: GetConfig200ResponseAdyenDataphonesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'poiid': value['poiid'],
        'name': value['name'],
        'ip': value['ip'],
    };
}

